import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, HTMLSelect, InputGroup, TextArea, Switch, RadioGroup, Radio } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj } from "../../utils";
import IntlCurrencyInput from "react-intl-currency-input";
import QRCode from "qrcode.react";
import moment from "moment";
import { PgdasStore } from "../../stores/pgdas/PgdasStore";
const numeral = require("numeral");
const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};
@observer
export default class SolicitaPgdas extends React.Component<{}, {}> {

    obs = observable({
        selectEmpresa: newEmpresa() as IEmpresa,
        open_buy_chave: false as boolean,
        quantidade: "" as string,
        valor_total: 0 as number,
        credito_restantes: 0 as number,
        count: 0 as number,
        pagamento_pix: false as boolean,
        interval: [] as any,
        ano: "2023" as string,
        competencia: "01" as string,
        retificar: false as boolean,
        selected_regime: "" as string,
        valor_adicional: "" as string,
        optante: true as boolean,
        esfera: 0 as number,
        processo: "" as string,
        gerar_das: false as boolean,
    })

    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        this.obs.ano = moment(new Date()).format("YYYY")
    }

    handleFormataReal(vl: string): string {
        let str = vl.replace("R$", "").trim().replace(",", "").replace(".", "");
        let total = str.length;
        let inicio = str.slice(0, total - 2);
        let fim = str.slice(total - 2);

        return (inicio + "." + fim);
    }
    async handleCriarTransmissao() {
        if (this.obs.selectEmpresa.cnpj === "") {
            toast.warning('Selecione uma empresa.', {});
            return;
        }

        if (!this.obs.competencia) {
            toast.warning('Selecione uma competência.', {});
            return;
        }
        if (!this.obs.ano) {
            toast.warning('Selecione um ano.', {});
            return;
        }

        if (!this.obs.optante) {

            if (this.obs.esfera == 0) {
                toast.warning('Selecione uma Esfera.', {});
                return;
            }
            if (this.obs.processo == "") {
                toast.warning('Digite o código do processo.', {});
                return;
            }
        }

        PgdasStore.obs.transmitirPgdas = false

        await PgdasStore.handleTransmissao(this.obs.selectEmpresa.cnpj, this.obs.competencia, this.obs.ano, this.obs.retificar, this.obs.selected_regime, this.handleFormataReal(this.obs.valor_adicional), this.obs.esfera, this.obs.processo, this.obs.gerar_das);
    }

    handleMonths() {
        return (<>
            <option value="01">Janeiro</option>
            <option value="02">Fevereiro</option>
            <option value="03">Março</option>
            <option value="04">Abril</option>
            <option value="05">Maio</option>
            <option value="06">Junho</option>
            <option value="07">Julho</option>
            <option value="08">Agosto</option>
            <option value="09">Setembro</option>
            <option value="10">Outubro</option>
            <option value="11">Novembro</option>
            <option value="12">Dezembro</option>
        </>);
    }

    handleAnos() {
        let m = moment();
        let ano = m.year() - 1;

        return (<>
            <option value={ano + 1}>{ano + 1}</option>
            <option value={ano}>{ano}</option>
        </>)
    }

    handleChangeCompetencia(competencia: string) {
        if (competencia != "1") { this.obs.selected_regime = "" }
        this.obs.competencia = competencia
    }

    handleCloseProgramar() {
        PgdasStore.obs.transmitirPgdas = false;
        this.obs.ano = moment(new Date()).format("YYYY")
        this.obs.selectEmpresa = newEmpresa();
    }

    render() {
        let empresaText = this.obs.selectEmpresa.cnpj != ""
            ? `${this.obs.selectEmpresa.razao_social} (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
            : "Selecione uma empresa";

        const currencyConfig = {
            locale: "pt-BR",
            formats: {
                number: {
                    BRL: {
                        style: "currency",
                        currency: "BRL",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    },
                },
            },
        };

        return (
            <>
                <FormGroup className="empresaSelect" label="Empresa">
                    <EmpresaSelect
                        items={EmpresaStore.sortedEmpresas.filter(x => {
                            return x.lista_rbt12 && x.simples_nacional && !x.filial;
                        })}
                        itemRenderer={renderEmpresa}
                        itemPredicate={filterEmpresa}
                        onItemSelect={(e: IEmpresa) => this.obs.selectEmpresa = e}
                        inputProps={{ placeholder: "Filtrar uma empresa" }}
                    >
                        <Button
                            text={empresaText}
                            rightIcon="double-caret-vertical"
                            alignText={Alignment.LEFT}
                        />
                    </EmpresaSelect>
                </FormGroup>

                <FormGroup label="Competência:" className="inputsPeriodoCalculos">
                    <HTMLSelect
                        value={this.obs.competencia}
                        onChange={(e) => this.handleChangeCompetencia(e.target.value)}
                        disabled={false}
                    >
                        {this.handleMonths()}
                    </HTMLSelect>
                </FormGroup>

                <FormGroup label="Ano:" className="inputsPeriodoCalculos">
                    <HTMLSelect
                        value={this.obs.ano}
                        onChange={(e) => { this.obs.ano = e.target.value }}
                        disabled={false}
                    >
                        {this.handleAnos()}
                    </HTMLSelect>
                </FormGroup>

                {this.obs.competencia == "11" &&
                    <>
                        <p><b>Obs:</b> Antes de efetuar a apuração desejada, é necessário definir o regime de apuração das receitas para o <br /> ano-calendário de {moment().add(1, "years").format("YYYY")}. Caso já tenha realizado selecione <b>Ignorar</b>.</p>

                        <RadioGroup onChange={(e: any) => this.obs.selected_regime = e.target.value} selectedValue={this.obs.selected_regime}>
                            <Radio label="Ignorar" value="" />
                            <Radio label="Caixa" value="caixa" />
                            <Radio label="Competência" value="competencia" />
                        </RadioGroup>

                    </>
                }

                <FormGroup label="Valor adicional">
                    <IntlCurrencyInput
                        className="form-control"
                        onChange={(e: any) => { this.obs.valor_adicional = e.target.value }}
                        currency="BRL"
                        config={currencyConfig}
                    />
                </FormGroup>

                <div style={{ display: "flex", verticalAlign: "middle" }}>
                    <FormGroup label="Gerar DAS automaticamente após a Transmissão:" />
                    <Switch
                        innerLabelChecked="Sim"
                        innerLabel="Não"
                        checked={this.obs.gerar_das}
                        onChange={(e: any) => this.obs.gerar_das = e.target.checked}
                        style={{ marginTop: "2px", marginLeft: 5 }}
                    />
                </div>
                    
                <MDBRow>                  
                    <MDBCol md="4">
                        <div style={{ display: "flex", verticalAlign: "middle" }}>
                            <FormGroup label="Retificar" />
                            <Switch
                                innerLabelChecked="Sim"
                                innerLabel="Não"
                                checked={this.obs.retificar}
                                onChange={(e: any) => this.obs.retificar = e.target.checked}
                                style={{ marginTop: "2px", marginLeft: 5 }}
                            />
                        </div>
                    </MDBCol>
                    <MDBCol md="4">
                        <div style={{ display: "flex", verticalAlign: "middle" }}>
                            <FormGroup label="Optante" />
                            <Switch
                                innerLabelChecked="Sim"
                                innerLabel="Não"
                                checked={this.obs.optante}
                                onChange={(e: any) => this.obs.optante = e.target.checked}
                                style={{ marginTop: "2px", marginLeft: 5 }}
                            />
                        </div>
                    </MDBCol>
                </MDBRow>
                {!this.obs.optante &&
                    <>

                        <FormGroup label="Esfera" className="inputsPeriodoCalculos">
                            <HTMLSelect
                                value={this.obs.esfera}
                                onChange={(e) => this.obs.esfera = parseInt(e.target.value)}
                            >
                                <option value={0}>Selecione</option>
                                <option value={1}>Federal</option>
                                <option value={2}>Distrial</option>
                                <option value={3}>Estadual</option>
                                <option value={4}>Municipal</option>
                            </HTMLSelect>
                        </FormGroup>

                        <FormGroup label="Processo">
                            <InputGroup
                                value={this.obs.processo}
                                onChange={(e: any) => this.obs.processo = e.target.value}
                            />
                        </FormGroup>

                    </>
                }

                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button text="Cancelar" onClick={() => this.handleCloseProgramar()} />
                    <Button text="Transmitir" intent="primary" onClick={() => this.handleCriarTransmissao()} />
                </div>

            </>
        )
    }
}

